import { Container } from "./Container";
import { Section } from "./Section";
import { Title } from "./Title";

const Resource = Container;
Resource.Section = Section;
Resource.Title = Title;

export { Resource };
